import { useEffect, useState } from "react";
import { ApiCall, BindDropDownList, NotificationSound, currentDate, getBeforeDate, handleDateChange, handleDownloadExcel, setFocus } from "../../Common/Common";
import { AutoCompleteBoxNew, CustomButton, DateBox, InputBox, SelectInputBox } from "../../Common/Input";
import { NewTable } from "../../Common/NewTable";

const PaymentReport = () => {
    const [tableLoading, setTableLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ sortColumn: null, sortOrder: null });
    const [pageSize, setPageSize] = useState("10");
    const [filterData, setFilterData] = useState({
        type: "S",
        searchText: "",
        searchFieldValue: "",
        startValue: "",
        AdvanceFilter: []
    })
    const initialState = {
        DateFrom: getBeforeDate(7),
        DateTo: currentDate(),
        UserName: '',
        PaymentStatus: '',
        Branch: '',
        WorkType: '',
        UTRNo: '',
    }
    const [formData, setFormData] = useState(initialState);

    const handleChange1 = (event, pagenumber) => {
        setCurrentPageNo(pagenumber)
    }

    let { data: PaymentStatus } = BindDropDownList('StatusMaster', 'StatusCode', 'Status', "  And IsPaymentStatus = 1")

    const ShowUserLogReport = async (formData) => {
        let request = {
            ...filterData,
            ...sortConfig,
            ...formData,
            pageSize: pageSize,
            pageIndex: `${currentPageNo}`
        }
        setTableLoading(true)
        let response = await ApiCall(`/api/Report/PaymentReport`, { ...request })
        if (response.Status === 'SUCCESS') {
            setTableData(response);
            setTableLoading(false)
        } else if (response.Status === 'ERROR') {
            setTableData([]);
            setTableLoading(false)
        } else {
            setTableLoading(false)
            NotificationSound(response.Status, response.Message, response.focus)
        }
    }

    const handleReset = async () => {
        await setFormData(initialState)
        ShowUserLogReport(initialState)
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleDownLoadExcel = () => {
        let request = {
            ...sortConfig,
            pageIndex: `${currentPageNo}`,
            pageSize: pageSize,
            Type: 'E',
            AdvanceFilter: [{
                "SearchingValue": filterData.SearchFieldValue,
                "ComparisonType": filterData.StartValue,
                "SearchingText": filterData.SearchText,
                "SearchingText1": '',
            }],
        }
        handleDownloadExcel('/api/Report/PaymentReport', 'Payment Report', request)
    }


    useEffect(() => {
        document.title = 'Payment Report'
        setFocus('txtDateFrom')
        ShowUserLogReport(formData)
    }, [currentPageNo, sortConfig, pageSize])

    return (
        <>
            <div className="my-5 rounded-xl border bg-white p-3">
                <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                    <DateBox
                        id='txtDateFrom'
                        label='Date From'
                        placeholder='Date From'
                        selected={formData.DateFrom === '' ? '' : new Date(formData.DateFrom)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateFrom')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtDateTo')
                            }
                        }}
                    />
                    <DateBox
                        id='txtDateTo'
                        label='Date To'
                        placeholder='Date To'
                        selected={formData.DateTo === '' ? '' : new Date(formData.DateTo)}
                        onChange={(e) => handleDateChange(e, setFormData, formData, 'DateTo')}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtUserName')
                            }
                        }}
                    />
                    <AutoCompleteBoxNew
                        id='txtUserName'
                        label='User Name'
                        placeholder='User Name'
                        autocompleteType='GetUserCode'
                        value={formData?.UserName || ''}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            setFormData((prevData) => ({
                                ...prevData,
                                UserName: newInputValue
                            }))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtJobCode');
                            }
                        }}
                    />

                    <SelectInputBox
                        id="txtPaymentStatus"
                        label="Payment Status"
                        value={formData.PaymentStatus ? formData.PaymentStatus : ""}
                        onChange={(e) => {
                            setFormData((prevData) => ({
                                ...prevData,
                                PaymentStatus: e.target.value
                            }))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus("txtMobileNumber")
                            }
                        }}
                    >
                        <option>--Choose Payment Status--</option>
                        {
                            PaymentStatus?.dropDownList?.map((item, index) => {
                                return (
                                    <option key={index} value={item.valuePart}>{item.textPart}</option>
                                )
                            })
                        }
                    </SelectInputBox>

                  
                 
                    <AutoCompleteBoxNew
                        id='txtBranch'
                        label='Branch'
                        placeholder='Branch'
                        autocompleteType='GetBranchName'
                        value={formData?.Branch || ''}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            setFormData((prevData) => ({
                                ...prevData,
                                Branch: newInputValue
                            }))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtWorkType');
                            }
                        }}
                    />
                    <AutoCompleteBoxNew
                        id='txtWorkType'
                        label='Work Type'
                        placeholder='Work Type'
                        autocompleteType='GetWorkType'
                        value={formData?.WorkType || ''}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            setFormData((prevData) => ({
                                ...prevData,
                                WorkType: newInputValue
                            }))
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setFocus('txtMobileNo');
                            }
                        }}
                    />

                    <InputBox
                        label={'UTR No'}
                        placeholder={'UTR No'}
                        id={'txtUTRNo'}
                        value={formData.UTRNo}
                        onChange={(e) => setFormData((prevData) => ({
                            ...prevData,
                            UTRNo: e.target.value,
                        }))}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                setFocus("btn_Save")
                            };
                        }}
                    />
                </div>
                <div className="mt-3 flex items-center gap-3">
                    <CustomButton
                        label='Search'
                        id={'btn_Save'}
                        color={'yellow'}
                        onClick={(e) => ShowUserLogReport(formData)}
                    />

                    <CustomButton
                        label='Reset'
                        id={'btn_Reset'}
                        color={'red'}
                        onClick={async () =>
                            handleReset()

                        }
                    />
                </div>
            </div>
            <NewTable
                tableLoading={tableLoading}
                PageName={'LedgerViewReport'}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                handleFilter={() => {
                    setFilterData({
                        ...filterData,
                    })
                }}
                pageSize={pageSize}
                setPageSize={setPageSize}
                Filter={false}
                exportExcelData={true}
                handleDownLoadExcel={handleDownLoadExcel}
            />
        </>
    )
}

export default PaymentReport